import actions from "./actions";

const resetFilters = actions.resetFilters;
const manualRehydrateFilter = actions.manualRehydrateFilter;
const setActiveDrawTool = actions.setActiveDrawTool;
const setFilterGeometry = actions.setFilterGeometry;
const setUseExtentFilter = actions.setUseExtentFilter;
const setFilterLoading = actions.setFilterLoading;
const setMapDrawingPaused = actions.setMapDrawingPaused;
const setFilterVisible = actions.setFilterVisible;
const setBasicFilterActive = actions.setBasicFilterActive;
const addFireCause = actions.addFireCause;
const removeFireCause = actions.removeFireCause;
const clearFireCause = actions.clearFireCause;
const addInitialStrategy = actions.addInitialStrategy;
const setNarrativeFilter = actions.setNarrativeFilter;
const removeInitialStrategy = actions.removeInitialStrategy;
const clearInitialStrategy = actions.clearInitialStrategy;
const clearIrwinRelationships = actions.clearIrwinRelationships;
const removeIrwinRelationship = actions.removeIrwinRelationship;
const addIrwinRelationship = actions.addIrwinRelationship;
const addDataSource = actions.addDataSource;
const removeDataSource = actions.removeDataSource;
const clearDataSources = actions.clearDataSources;
const addInitialType = actions.addInitialType;
const removeInitialType = actions.removeInitialType;
const clearInitialType = actions.clearInitialType;
const addLandownerCategory = actions.addLandownerCategory;
const removeLandownerCategory = actions.removeLandownerCategory;
const clearLandownerCategory = actions.clearLandownerCategory;
const setFireAcreage = actions.setFireAcreage;
const clearFireAcreage = actions.clearFireAcreage;
const setFireDiscoveryDates = actions.setFireDiscoveryDates;
const clearFireDiscoveryDates = actions.clearFireDiscoveryDates;
const setFireOutDates = actions.setFireOutDates;
const clearFireOutDates = actions.clearFireOutDates;
const setModifiedDates = actions.setModifiedDates;
const setImsrDates = actions.setImsrDates;
const clearModifiedDates = actions.clearModifiedDates;
const clearImsrDates = actions.clearImsrDates;
const setStructuresFilter = actions.setStructuresFilter;
const setInjuriesFilter = actions.setInjuriesFilter;
const setUniquenessFilter = actions.setUniquenessFilter;
const setFatalitiesFilter = actions.setFatalitiesFilter;
const setOtherStructuresDestroyedFilter = actions.setOtherStructuresDestroyedFilter;
const setResidencesThreatenedFilter = actions.setResidencesThreatenedFilter;
const setOtherStructuresThreatenedFilter = actions.setOtherStructuresThreatenedFilter;
const setCertifiedFilter = actions.setCertifiedFilter;
const setGaccFilter = actions.setGaccFilter;
const setResponseAgenciesFilter = actions.setResponseAgenciesFilter;
const setStateFilter = actions.setStateFilter;
const setCountyFilter = actions.setCountyFilter;
const setModifiedBySystemFilter = actions.setModifiedBySystemFilter;
const setCapabilityRequestsFilter = actions.setCapabilityRequestsFilter;
const setCreatedBySystemFilter = actions.setCreatedBySystemFilter;
const setReportSearchTerms = actions.setReportSearchTerms;
const setPOOIncidentJurisdictionalAgency = actions.setPOOIncidentJurisdictionalAgency;
const setDispatchCenterID = actions.setDispatchCenterID;
const setPOOProtectingUnit = actions.setPOOProtectingUnit;
const setPOOProtectingAgency = actions.setPOOProtectingAgency;
const setPOOJurisdictionalUnit = actions.setPOOJurisdictionalUnit;
const addUniqueFireIdentifier = actions.addUniqueFireIdentifier;
const removeUniqueFireIdentifier = actions.removeUniqueFireIdentifier;
const clearUniqueFireIdentifiers = actions.clearUniqueFireIdentifiers;
const setPerimeterMapMethod = actions.setPerimeterMapMethod;
const setPerimeterFeatureStatus = actions.setPerimeterFeatureStatus;
const setPerimeterFeatureAccess = actions.setPerimeterFeatureAccess;
const setMultiRoot = actions.setMultiRoot;
const setInImsr = actions.setInImsr;
const setUtcOffsetFilter = actions.setUtcOffsetFilter;
const clearUtcOffsetFilter = actions.clearUtcOffsetFilter;
const clearPerimeterAcreage = actions.clearPerimeterAcreage;
const setPerimeterAcreageOperator = actions.setPerimeterAcreageOperator;
const setPerimeterAcreageLandowner = actions.setPerimeterAcreageLandowner;
const setPerimeterAcreageNumber = actions.setPerimeterAcreageNumber;
const clearPerimeterBeneficial = actions.clearPerimeterBeneficial;
const setPerimeterBeneficialOperator = actions.setPerimeterBeneficialOperator;
const setPerimeterBeneficialLandowner = actions.setPerimeterBeneficialLandowner;
const setPerimeterBeneficialNumber = actions.setPerimeterBeneficialNumber;
const setHasSpatialFilter = actions.setHasSpatialFilter;
const setSpatialFilterID = actions.setSpatialFilterID;
//const setPerimeterAcreageIds = actions.setPerimeterAcreageIds;

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  manualRehydrateFilter,
  setActiveDrawTool,
  setFilterGeometry,
  setUseExtentFilter,
  setFilterLoading,
  setMapDrawingPaused,
  setFilterVisible,
  addFireCause,
  removeFireCause,
  clearFireCause,
  addInitialStrategy,
  setNarrativeFilter,
  removeInitialStrategy,
  clearInitialStrategy,
  clearIrwinRelationships,
  addIrwinRelationship,
  removeIrwinRelationship,
  addDataSource,
  removeDataSource,
  clearDataSources,
  addInitialType,
  removeInitialType,
  setBasicFilterActive,
  clearInitialType,
  addLandownerCategory,
  removeLandownerCategory,
  clearLandownerCategory,
  setPerimeterMapMethod,
  setPerimeterFeatureStatus,
  setPerimeterFeatureAccess,
  setFireAcreage,
  clearFireAcreage,
  setFireDiscoveryDates,
  clearFireDiscoveryDates,
  setFireOutDates,
  clearFireOutDates,
  setModifiedDates,
  setImsrDates,
  clearModifiedDates,
  clearImsrDates,
  setStructuresFilter,
  setInjuriesFilter,
  setUniquenessFilter,
  setFatalitiesFilter,
  setOtherStructuresDestroyedFilter,
  setResidencesThreatenedFilter,
  setOtherStructuresThreatenedFilter,
  setCertifiedFilter,
  setGaccFilter,
  setResponseAgenciesFilter,
  setStateFilter,
  setCountyFilter,
  setModifiedBySystemFilter,
  setCapabilityRequestsFilter,
  setCreatedBySystemFilter,
  setReportSearchTerms,
  setPOOIncidentJurisdictionalAgency,
  setDispatchCenterID,
  setPOOProtectingUnit,
  setPOOProtectingAgency,
  setPOOJurisdictionalUnit,
  addUniqueFireIdentifier,
  removeUniqueFireIdentifier,
  clearUniqueFireIdentifiers,
  resetFilters,
  setMultiRoot,
  setInImsr,
  setUtcOffsetFilter,
  clearUtcOffsetFilter,
  setPerimeterAcreageNumber,
  setPerimeterAcreageOperator,
  setPerimeterAcreageLandowner,
  clearPerimeterAcreage,
  setPerimeterBeneficialNumber,
  setPerimeterBeneficialOperator,
  setPerimeterBeneficialLandowner,
  clearPerimeterBeneficial,
  setHasSpatialFilter,
  setSpatialFilterID
  //setPerimeterAcreageIds
};
